import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import './feedbackAssistantSdk'
import './styles/index.css'
import App from './App.vue'
import router from './router'
import { vPermission } from './directives/permission'
import { usePermissionStore } from './stores/permission'
import { initPointTracker } from './services/pointTracker'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// 设置时区为 UTC
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('UTC')

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(VueViewer, {
  defaultOptions: {
    navbar: false,
    title: false,
    toolbar: true,
    zIndex: 3000,
  },
})
app.directive('permission', vPermission)
usePermissionStore(pinia).startStorageSync()
initPointTracker()

app.mount('#app')
